import Axios from 'axios/index'
import Store from '../store'
import router from '../router'

// 生产环境
// Axios.defaults.baseURL = Store.state.httpHost.login
// 请求超出时间
Axios.defaults.timeout = 60000
// post请求头
Axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
// let loginMessage = Store.getters.getLoginMessage()
// Axios.defaults.headers.post[loginMessage.sessionKey] = loginMessage.sessionId

// 响应拦截器
Axios.interceptors.response.use(
  response => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    if (response.status === 200) {
      // console.log('账号1',localStorage.getItem('UserMessage'))
      // console.log('账号2',JSON.parse(localStorage.getItem('UserMessage')))
      // 如果未登录 传当前组件地址
      if (response.data.status === -1) {
        // return this.$forceUpdate()
        // console.log('二次登陆')
        // if(true){
        //   post(Store.state.httpHost.login+'/japi/login',
        //     {
        //       username: JSON.parse(localStorage.getItem('UserMessage')).user,
        //       password: JSON.parse(localStorage.getItem('UserMessage')).pass,
        //       from:'phone'
        //     }
        //   )
        //   return console.log('二次登陆成功')
        // }
        console.log('过期.....')
        // localStorage.removeItem('UserMessage')
        router.push({
          path: '/login',
          query: {redirect: router.currentRoute.fullPath}
        })
      } else {
        return Promise.resolve(response)
      }
    } else {
      return Promise.reject(response)
    }
  },
  // 服务器状态码不是2开头的的情况
  error => {
    console.log('http:error',error)
    Store.state.state.loading = false
    if (error.response.status) {
      // switch (error.response.status) {
      //   // 401: 未登录 替换成登录页
      //   case 401:
      //     router.replace({
      //       path: '/login',
      //       query: {
      //         redirect: router.currentRoute.fullPath
      //       }
      //     })
      //     break
      //
      //   // 403 token过期
      //   // 登录过期对用户进行提示
      //   // 清除本地token和清空vuex中token对象
      //   // 跳转登录页面
      //   case 403:
      //     this.$toast({
      //       message: '登录过期，请重新登录',
      //       duration: 1000,
      //       forbidClick: true
      //     })
      //     // 清除token
      //     localStorage.removeItem('token')
      //     // store.commit('loginSuccess', null)
      //     // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
      //     setTimeout(() => {
      //       router.replace({
      //         path: '/login',
      //         query: {
      //           redirect: router.currentRoute.fullPath
      //         }
      //       })
      //     }, 1000)
      //     break
      //
      //   // 404请求不存在
      //   case 404:
      //     this.$toast({
      //       message: '网络请求不存在',
      //       duration: 1500,
      //       forbidClick: true
      //     })
      //     break
      //   // 其他错误，直接抛出错误提示
      //   default:
      //     this.$toast({
      //       message: error.response.data.message,
      //       duration: 1500,
      //       forbidClick: true
      //     })
      // }
      return Promise.reject(error.response)
    }
  }
)

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get (url, headers) {
  let urlArray = url.split('/')
  let loginMessage = Store.getters.getLoginMessage()
  if (urlArray[urlArray.length - 1] !== 'login' && loginMessage.sessionKey !== undefined) {
    Axios.defaults.headers.get[loginMessage.sessionKey] = loginMessage.sessionId
  } else if (loginMessage.sessionKey !== undefined) {
    Axios.defaults.headers.get[loginMessage.sessionKey] = ''
  }
  return new Promise((resolve, reject) => {
    Axios.get(url, headers).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * 通过node的qs模块来序列化我们的参数  没有序列化操作，后台是拿不到你提交的数据
 */
export function post (url, params, headers) {
  let urlArray = url.split('/')
  let loginMessage = Store.getters.getLoginMessage()
  if (urlArray[urlArray.length - 1] !== 'login' && loginMessage.sessionKey !== undefined && urlArray[urlArray.length - 1].indexOf("thirdLogin")== -1) { //thirdLogin 单点登录
    Axios.defaults.headers.post[loginMessage.sessionKey] = loginMessage.sessionId
  } else if (loginMessage.sessionKey !== undefined) {
    Axios.defaults.headers.post[loginMessage.sessionKey] = ''
  }
  return new Promise((resolve, reject) => {
    Axios.post(url, params, headers)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        console.log('post:::::reject', err)
        reject(err)
      })
  })
}



// WEBPACK FOOTER //
// ./src/http/index.js